import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface SnackBarData {
  message: string;
  action?: string;
  icon?: string;
  type?: 'default' | 'success' | 'error' | 'info' | 'warning';
}

@Component({
  selector: 'app-snack-bar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
export class SnackBarComponent {
  // --------------- Injecciones --------------- //
  readonly data = inject(MAT_SNACK_BAR_DATA) as SnackBarData;
  private readonly _snackRef = inject(MatSnackBarRef<SnackBarComponent>);

  onAction(): void {
    this._snackRef.dismissWithAction();
  }
}
